import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3c8535fd"),n=n(),_popScopeId(),n)
const _hoisted_1 = { key: "item" }
const _hoisted_2 = { class: "d-flex justify-content-between mb-2" }
const _hoisted_3 = {
  class: "d-inline",
  style: {"font-size":"1.1rem"}
}
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-exclamation-triangle" }, null, -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-exclamation-circle" }, null, -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-check-circle" }, null, -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-times-circle" }, null, -1))
const _hoisted_8 = { class: "d-flex justify-content-between mb-2" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"font-size":".8rem"} }, "Current Reading:", -1))
const _hoisted_10 = { style: {"font-weight":"600"} }
const _hoisted_11 = { class: "d-flex justify-content-between mb-2" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"font-size":".8rem"} }, "Range:", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_n_tag = _resolveComponent("n-tag")!
  const _component_n_table = _resolveComponent("n-table")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_n_table, null, {
      default: _withCtx(() => [
        _createElementVNode("tbody", null, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.equipment.sensors, (item) => {
            return (_openBlock(), _createElementBlock("tr", _hoisted_1, [
              _createElementVNode("td", null, [
                _createElementVNode("div", _hoisted_2, [
                  _createElementVNode("b", _hoisted_3, [
                    _createElementVNode("span", {
                      class: "dot",
                      style: _normalizeStyle('background: ' + item.color)
                    }, null, 4),
                    _createTextVNode(" " + _toDisplayString(item.name), 1)
                  ]),
                  (_ctx.status(item.last_reading) && item.alarm_type == 77)
                    ? (_openBlock(), _createBlock(_component_n_tag, {
                        key: 0,
                        round: "",
                        bordered: false,
                        type: "warning"
                      }, {
                        icon: _withCtx(() => [
                          _hoisted_4
                        ]),
                        default: _withCtx(() => [
                          _createTextVNode(" Warning ")
                        ]),
                        _: 1
                      }))
                    : (_ctx.status(item.last_reading) && item.alarm_type == 78)
                      ? (_openBlock(), _createBlock(_component_n_tag, {
                          key: 1,
                          round: "",
                          bordered: false,
                          type: "error"
                        }, {
                          icon: _withCtx(() => [
                            _hoisted_5
                          ]),
                          default: _withCtx(() => [
                            _createTextVNode(" Critical ")
                          ]),
                          _: 1
                        }))
                      : (_ctx.status(item.last_reading))
                        ? (_openBlock(), _createBlock(_component_n_tag, {
                            key: 2,
                            round: "",
                            bordered: false,
                            type: "success"
                          }, {
                            icon: _withCtx(() => [
                              _hoisted_6
                            ]),
                            default: _withCtx(() => [
                              _createTextVNode(" Active ")
                            ]),
                            _: 1
                          }))
                        : (!_ctx.status(item.last_reading))
                          ? (_openBlock(), _createBlock(_component_n_tag, {
                              key: 3,
                              round: "",
                              bordered: false
                            }, {
                              icon: _withCtx(() => [
                                _hoisted_7
                              ]),
                              default: _withCtx(() => [
                                _createTextVNode(" Inactive ")
                              ]),
                              _: 1
                            }))
                          : _createCommentVNode("", true)
                ]),
                _createElementVNode("div", _hoisted_8, [
                  _hoisted_9,
                  _createElementVNode("span", _hoisted_10, [
                    _createTextVNode(_toDisplayString(_ctx.status(item.last_reading) ? item.value : "-") + " ", 1),
                    _createElementVNode("small", null, _toDisplayString(item.unit), 1)
                  ])
                ]),
                _createElementVNode("div", _hoisted_11, [
                  _hoisted_12,
                  _createElementVNode("span", null, [
                    _createTextVNode(_toDisplayString(item.min_threshold) + " ", 1),
                    _createElementVNode("small", null, _toDisplayString(item.unit), 1),
                    _createTextVNode(" - " + _toDisplayString(item.max_threshold) + " ", 1),
                    _createElementVNode("small", null, _toDisplayString(item.unit), 1)
                  ])
                ])
              ])
            ]))
          }), 128))
        ])
      ]),
      _: 1
    })
  ]))
}